import React, { Component } from "react";
import postService from "../../services/postService";
import CircularLoadingScreen from "../commons/CircularLoadingScreen";
import PostList from "./PostList";

class Bookmarks extends Component {
  state = {
    loadedBookmarks: false,
    bookmarks: [],
  };

  async componentDidMount() {
    this.loadBookmarks();
  }

  loadBookmarks = async () => {
    const response = await postService.getBookmarked();
    const posts = response.data.data;
    this.setState({
      loadedBookmarks: true,
      bookmarks: posts,
    });
  };

  render() {
    const { loadedBookmarks, bookmarks } = this.state;
    return (
      <div>
        <div style={{ padding: "0 20px" }}>
          <h2 className="heading">Bookmarked posts</h2>
          <p>See a memorable post? Bookmark it!</p>
        </div>
        {!loadedBookmarks ? (
          <CircularLoadingScreen thickness={5} />
        ) : (
          <div className="posts">
            <PostList posts={bookmarks} noPostsError="You have no bookmarked posts" />
          </div>
        )}
      </div>
    );
  }
}

export default Bookmarks;
